/*
 *
 * Page: `@dbh/invoices-payment-form-page`.
 *
 */const importInvoicesPaymentFormPage=()=>import('./component-98d90681.js'/*  webpackChunkName: 'dbh.invoices-payment-form-page.component' */);const importInvoicesPaymentFormPageSsr=()=>import('./ssr-452cccc0.js'/*  webpackChunkName: 'dbh.invoices-payment-form-page.ssr' */);

export { importInvoicesPaymentFormPage, importInvoicesPaymentFormPageSsr };
